import { damageService, issueNoService, mappingService } from '../services';
import { damageConstants } from '../constants';
import { alertActions } from '.';
import { history } from '../helpers';

export const damageActions = {
    getAll,
    createDamage,
    updateDamage,
    onHideShow
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());

        issueNoService.fetchIssueNoData(obj).then(response => {
            ;
            dispatch(success(response.ResponseData))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request() { return { type: damageConstants.GETALL_REQUEST } }
    function success(datas) { return { type: damageConstants.GETALL_SUCCESS, datas } }
    function failure(error) { return { type: damageConstants.GETALL_FAILURE, error } }
}

function createDamage(data) {
    
    return dispatch => {
        dispatch(request(data));

        damageService.createDamage(data).then(
            response => {               
                //history.push('/');
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(response.ResponseData));
                        dispatch(onHideShow(false));
                        dispatch(alertActions.success(response.ResponseMessage));
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: damageConstants.CREATE_REQUEST, data } }
    function success(data) { return { type: damageConstants.CREATE_SUCCESS, data } }
    function failure(error) { return { type: damageConstants.CREATE_FAILURE, error } }
};

function updateDamage(data) {
    return dispatch => {
        dispatch(request(data));

        damageService.createDamage(data).then(
            response => {
                dispatch(success(data));
                //history.push('/');                
                if (response && response.ResponseCode) {
                    response.ResponseCode == "200" ? dispatch(alertActions.success(response.ResponseMessage))
                        : response.ResponseCode == "400" ? dispatch(alertActions.warning(response.ResponseMessage))
                        : dispatch(alertActions.error(response.ResponseMessage))
                }
            },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }
        );
    };

    function request(data) { return { type: damageConstants.UPDATE_REQUEST, data } }
    function success(data) { return { type: damageConstants.UPDATE_SUCCESS, data } }
    function failure(error) { return { type: damageConstants.UPDATE_FAILURE, error } }
};

function onHideShow(isbool) {
    return {
        type: damageConstants.DIALOG_REQUEST, isbool
    }
}



